import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-ink flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="text-center max-w-lg"
      >
        <h1 className="font-serif text-5xl font-light" data-testid="payment-cancel-heading">
          The stance <span className="italic gold-text-gradient">awaits.</span>
        </h1>
        <p className="mt-6 text-ash leading-relaxed">
          Your checkout was cancelled — no charge was made. The collection will be here when you're ready.
        </p>
        <Link
          to="/"
          className="mt-12 inline-block rounded-full border border-gold/60 px-10 py-4 text-xs uppercase tracking-[0.25em] text-gold hover:bg-gold hover:text-ink transition-colors duration-500"
          data-testid="payment-cancel-home-link"
        >
          Back to the Collection
        </Link>
      </motion.div>
    </div>
  );
}
